import React from 'react'

export const BurnIndicator = () => (
    <div className="m-auto block h-8 w-8">
        <img className="m-auto" src="/fire.png" />
    </div>
)

export default BurnIndicator
